import React, { useEffect, useState } from "react";
import { Search, Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { matchesMember } from "../lib/memberSearch";
import { Avatar } from "./Media";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

// Pick any sovereign to start (or reopen) an encrypted Exchange.
export const NewExchangeDialog = ({ open, onOpenChange, onPick }) => {
  const { user } = useAuth();
  const [members, setMembers] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    if (!open || members) return;
    api.get("/members").then(({ data }) => setMembers((data || []).filter((m) => m.id !== user?.id))).catch(() => setMembers([]));
  }, [open, members, user?.id]);
  const list = (members || []).filter((m) => matchesMember(m, q)).slice(0, 50);
  return (
    <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) setQ(""); }}>
      <DialogContent className="bg-[#0F0F0F] border-white/10 text-white max-w-md p-0 gap-0" data-testid="new-exchange-dialog">
        <DialogHeader className="px-5 pt-5 pb-3">
          <DialogTitle className="font-heading text-xl text-[#14A89A]">New exchange</DialogTitle>
          <p className="font-body text-xs text-zinc-500">Choose a sovereign, your exchange is end-to-end encrypted.</p>
        </DialogHeader>
        <div className="px-5 pb-3">
          <div className="flex items-center gap-2 border border-white/15 px-3 focus-within:border-[#14A89A] transition-colors">
            <Search size={15} className="text-zinc-500" />
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name or headline" data-testid="new-exchange-search"
              className="flex-1 bg-transparent py-2.5 font-body text-sm outline-none placeholder:text-zinc-600" />
          </div>
        </div>
        <div className="max-h-[50vh] overflow-y-auto border-t border-white/10" data-testid="new-exchange-results">
          {members === null ? <div className="flex justify-center py-8"><Loader2 className="animate-spin text-zinc-500" size={20} /></div>
            : list.length === 0 ? <p className="font-body text-sm text-zinc-600 p-5" data-testid="new-exchange-empty">No sovereigns match "{q}".</p>
            : list.map((m) => (
              <button key={m.id} type="button" onClick={() => { onOpenChange(false); setQ(""); onPick(m.id); }} data-testid={`new-exchange-member-${m.id}`}
                className="w-full flex items-center gap-3 px-5 py-3 hover:bg-white/5 transition-colors text-left">
                <Avatar name={m.name} src={m.avatar} size={36} />
                <span className="min-w-0 flex-1">
                  <span className="block font-body text-sm text-white truncate">{m.name}</span>
                  {m.headline && <span className="block font-body text-xs text-zinc-500 truncate">{m.headline}</span>}
                </span>
              </button>
            ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
